
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertEmpty as ObiAlertEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-empty.js';
 
 
 

 
 export const ObiAlertEmpty = createComponent({
   react: React,
   tagName: 'obi-alert-empty',
   elementClass: ObiAlertEmptyElement,
   events: {
     
   }
  });
 
 